(function () {
  if (window.__feniksTouchGuardLoaded) return;
  window.__feniksTouchGuardLoaded = true;

  var mobileQuery = window.matchMedia('(max-width: 767px)');
  var supportsTouch = ('ontouchstart' in window) || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
  if (!supportsTouch) return;

  var horizontalSelector = [
    'slider-element',
    '.slider',
    '.flickity-slider',
    '.flickity-enabled',
    '.flickity-viewport',
    '.video-carousel__track',
    '.process-tabs-nav',
    '.process-grid',
    '.marstek-product-carousel__slider',
    '.marstek-why-buy__slider',
    '[is="icons-carousel"]',
    '.product-card__icons',
    '.scroll-area'
  ].join(',');

  var activeScroller = null;
  var startX = 0;
  var startY = 0;
  var startScrollLeft = 0;
  var gesture = null;

  function findHorizontalArea(target) {
    var explicit = target.closest(horizontalSelector);
    if (explicit) return explicit;

    var element = target;
    while (element && element !== document.body) {
      var style = window.getComputedStyle(element);
      var canScrollX = /(auto|scroll)/.test(style.overflowX) && element.scrollWidth > element.clientWidth + 4;
      if (canScrollX) return element;
      element = element.parentElement;
    }

    return null;
  }

  function resetState() {
    activeScroller = null;
    gesture = null;
  }

  document.addEventListener('touchstart', function (event) {
    if (!mobileQuery.matches || event.touches.length !== 1) return;

    activeScroller = findHorizontalArea(event.target);
    if (!activeScroller) return;

    startX = event.touches[0].pageX;
    startY = event.touches[0].pageY;
    startScrollLeft = activeScroller.scrollLeft || 0;
    gesture = null;
  }, { passive: true, capture: true });

  document.addEventListener('touchmove', function (event) {
    if (!activeScroller || event.touches.length !== 1) return;

    var deltaX = event.touches[0].pageX - startX;
    var deltaY = event.touches[0].pageY - startY;
    var absX = Math.abs(deltaX);
    var absY = Math.abs(deltaY);

    if (!gesture && (absX > 10 || absY > 10)) {
      if (absX > 12 && absX > absY * 1.25) {
        gesture = 'horizontal';
      }
      else if (absY > absX * 1.05) {
        gesture = 'vertical';
      }
    }

    if (gesture === 'vertical') {
      if (typeof activeScroller.scrollLeft === 'number') {
        activeScroller.scrollLeft = startScrollLeft;
        requestAnimationFrame(function () {
          if (activeScroller && gesture === 'vertical') {
            activeScroller.scrollLeft = startScrollLeft;
          }
        });
      }

      event.stopImmediatePropagation();
    }
  }, { passive: true, capture: true });

  document.addEventListener('touchend', resetState, { passive: true, capture: true });
  document.addEventListener('touchcancel', resetState, { passive: true, capture: true });
})();
